<template>
  <BoxInput
    ref="radioInput"
    :class="{ 'formulate-input--hidden-input': hiddenInput }"
    type="radio"
    v-bind="$attrs"
    :value="value"
    @input="$emit('input', $event)"
    @go="$emit('go', $event)"
  />
</template>

<script>
import BoxInput from '@/lego/components/inputs/box/BoxInput.vue';
import { computed, ref } from '@vue/composition-api';

export default {
  components: {
    BoxInput,
  },
  props: {
    hiddenInput: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
  },
  setup() {
    const radioInput = ref();
    const children = computed(
      () => radioInput.value?.$children[0]?.$children[0]?.$children,
    );

    return {
      radioInput,
      children,
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  @apply w-full rounded-md bg-neutral-lightest;

  &--disabled {
    .formulate-input-label {
      @apply !text-neutral-semilight !border-neutral-semilight pointer-events-none hover:cursor-not-allowed before:!border-neutral-semilight;
    }
  }

  .formulate-input--disabled& {
    @apply cursor-not-allowed bg-neutral-white border-hairline border-neutral-semilight text-neutral-medium;

    .formulate-input-element-decorator {
      @apply cursor-not-allowed;
    }
  }

  &-wrapper {
    .appointment-time-range > & {
      @apply flex flex-col items-start;
    }
  }
  &-element {
    @apply border-none;

    &--group {
      @apply flex flex-col items-center w-full gap-y-xxxs;

      .appointment-time-range & {
        @apply grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 sm:gap-x-xxs gap-x-xxxs gap-y-xxxs;
      }
    }
    &--decorator {
      .formulate-input--hidden-input & {
        @apply !hidden;
      }
    }
  }
  &-group-item {
    @apply p-0 bg-neutral-white;

    &[data-has-value='true'] {
      .formulate-input-label {
        @apply bg-brand-secondary-lightest text-neutral-white;

        .appointment-time-range & {
          @apply before:bg-neutral-white before:border-thick before:border-brand-secondary-lightest before:outline before:outline-1 before:outline-neutral-white;
        }
      }
    }
  }
  &-label {
    @apply w-full p-xxxs border-hairline border-neutral-medium rounded-s;

    .appointment-time-range & {
      @apply style-body-sm py-xxxs px-xxxs lg:px-nano items-center gap-x-micro lg:gap-x-quark flex text-neutral-semidark before:border-neutral-semidark before:block before:content-[''] before:w-xxxs before:h-xxxs before:border-hairline before:rounded-circular before:flex-[0_0_auto];
    }
  }
  &-help {
    .appointment-time-range & {
      @apply style-body-sm text-brand-secondary-medium mt-0;
    }
  }

  input {
    @apply appearance-none cursor-pointer bg-neutral-white mr-micro w-xxxs h-xxxs border-hairline border-neutral-semilight !rounded-circular focus:outline-none;

    [data-has-value='true']& {
      @apply bg-support-dark border-[0.25rem] border-neutral-white;
    }

    .formulate-input--hidden-input & {
      @apply !hidden;
    }
  }
}
</style>
